import PropTypes from 'prop-types';
import React from 'react';
import { useParams } from 'react-router-dom';

import AdminBrowseCategoriesEditPage from 'app/components/admin/browse/categories/AdminBrowseCategoriesEditPage';

export function AdminBrowseCategoriesEditPageRoute({ basePageRoute }) {
  const { categoryConfigId, localeCode, topLevelCategoryId } = useParams();

  return (
    <AdminBrowseCategoriesEditPage
      basePageRoute={basePageRoute}
      categoryConfigId={categoryConfigId}
      localeCode={localeCode}
      topLevelCategoryId={topLevelCategoryId}
    />
  );
}

AdminBrowseCategoriesEditPageRoute.propTypes = {
  basePageRoute: PropTypes.string.isRequired
};

export default AdminBrowseCategoriesEditPageRoute;
